// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Menu = require("../../../common/Components/Menu.bs.js");
let Utils = require("../../../../utils/Utils.bs.js");
let IconV5 = require("../../../common/Components/IconV5.bs.js");
let ButtonsV5 = require("../../../common/Components/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function DuplicatePropertyError$ViewClientButton(props) {
  return JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
    href: `/my_clients/` + props.clientId,
    size: "small",
    children: [
      JsxRuntime.jsx(IconV5.make, {
        icon: "client"
      }),
      Utils.$$String.nbsp + "View Client"
    ]
  });
}

let ViewClientButton = {
  make: DuplicatePropertyError$ViewClientButton
};

function DuplicatePropertyError$ActionsDropdown(props) {
  return JsxRuntime.jsx(Menu.Menu.make, {
    button: JsxRuntime.jsxs(ButtonsV5.Button.make, {
      size: "small",
      className: "border border-gray-200 text-gray-600 hover:text-white hover:bg-tan-blue-500 hover:border-tan-blue-500",
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "arrow-down"
        }),
        Utils.$$String.nbsp + "Actions"
      ]
    }),
    children: props.children
  });
}

let ActionsDropdown = {
  make: DuplicatePropertyError$ActionsDropdown
};

exports.ViewClientButton = ViewClientButton;
exports.ActionsDropdown = ActionsDropdown;
/* Menu Not a pure module */
